import styled from 'styled-components';

export const ListContainer = styled.ul`
  width: 100%;
  padding: 0;
  margin: 0;
  list-style-type: none;

  & > li:nth-child(even) {
    background-color: ${props => (props.striped ? props.theme.colors.secondary98w : 'transparent')};
  }
`;

export const ListItem = styled.li`
  padding: 0;
  margin: 0;
`;
